import {RestResource} from '../rest'
import {DCIM_SERVER} from "../server";
import {athubAxios} from "@/util/athub-axios/index";

const locationOutside = new RestResource({server: DCIM_SERVER, resource: 'locationOutside'});

locationOutside.getByGuid = (guid) => {
    let url = `${DCIM_SERVER}/locationOutside/guid/${guid}`;
    return new Promise((resolve, reject) => {
        athubAxios.get(url).then(res => {
            if (res.data.code == 200) {
                resolve(res.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

export default locationOutside;
